import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import type { LoadStatus } from '@apps/stays/types';
import type { CashFundView } from './AccommodationsConsole.telemetry.types';
import type { CashFundBalanceTelemetry } from '@shared/utils/cashFund/cashFund.types';

export const accommodationsConsoleTelemetry = createTelemetryObject({
  actions: {
    pageViewed: () => ({
      category: 'wedding',
      action: 'PageViewed',
      extraInfo: {
        name: 'AccommodationsConsole',
      },
    }),
    onAccommodationsResultsLoaded: ({
      accommodations_results_loaded_ms,
      load_status,
      cash_fund_view,
      cashFundBalance = {},
    }: {
      accommodations_results_loaded_ms: number;
      load_status: LoadStatus;
      /** Which cash-fund treatment this search actually rendered. `none` on every other console. */
      cash_fund_view: CashFundView;
      /** The couple's spendable balance, so the search can be split by fund size. Empty off the fund console. */
      cashFundBalance?: CashFundBalanceTelemetry;
    }) => ({
      category: 'wedding',
      action: 'TravelButtonInteracted',
      extraInfo: {
        name: 'AccommodationsResultsLoaded',
        accommodations_results_loaded_ms,
        load_status,
        cash_fund_view,
        ...cashFundBalance,
      },
    }),
    /**
     * Fired once per search, by the first tile that renders a fund split. Separate from
     * `onAccommodationsResultsLoaded` on purpose: that event fires before the listings carry their
     * split, so it can only report the page variant, never what a tile actually showed.
     */
    cashFundSplitViewed: ({ cash_fund_view }: { cash_fund_view: CashFundView }) => ({
      category: 'accommodations',
      action: 'TravelButtonInteracted',
      extraInfo: {
        name: 'CashFundSplitViewed',
        cash_fund_view,
        from: 'Accommodations Console',
      },
    }),
  },
});

const { TelemetryProvider, useTelemetry } = createTelemetry(accommodationsConsoleTelemetry, { eventId: '', section: '' });

export { TelemetryProvider, useTelemetry as useAccommodationsConsoleTelemetry };
